// 導入圖片資源 (Vite 會處理編譯後的路徑)
import logoImg from '@/assets/images/3probe.png';

// 定義 Assets 模組
export const assets = {
    /** 系統圖示與商標 */
    brand: {
        logo: logoImg,
    },
    
    /** 使用者相關圖片 */
    user: {
    },

    /** 也可以處理遠端靜態資源的 URL 拼接 */
    remote(path: string): string {
        const base = (window as any).EXTERNAL_CONFIG?.IMAGE_SERVER || '';
        return `${base}${path}`;
    }
};

export type AssetsType = typeof assets;